import { Plan } from './components/Plan';
import withTableController from '../../../../HOC/tableController/withTableControllerForPlanning';

const Plan25 = withTableController(({ planing, handlePlaning }) => (
  <Plan planing={planing} handlePlaning={handlePlaning} />
));

export default Plan25;
